import { HttpRequestError }          from '../../models';

/**
 * Provides standard error handling for HTTP requests.
 */
export class HttpErrorHandler {

  /**
   * Returns HttpRequestError with the server error code
   */
  public static handleServerError(responseError: any, errorI18nLabel?: string): HttpRequestError {
    return new HttpRequestError( (responseError.errcode && responseError.errcode > 0) ? JSON.stringify(responseError.errcode) : '',
                                  errorI18nLabel ? errorI18nLabel : responseError.message,
                                  500, 
                                  responseError);
  }
}

/**
 * Handles standard HTTP errors giving the HTTP response status.
 *
 * @param response Http response sent by the server.
 * @param errorExt Additional Information you can pass to the err object.
 */
export function handleHttpError(response: any, message?: string): HttpRequestError {

    if (!response) {

      if (message && message === 'Network Error') {
        return new HttpRequestError('', 'app.common.error.server.unreachable', 522, response);
      } else {
        return new HttpRequestError('', 'app.common.error.server.unknown', 500);
      }

    } else {

      if (response.code && response.code === 'ECONNABORTED') { // Request timeout
        return new HttpRequestError('', 'app.common.error.server.timeout', 408, response);
      }

      if (!response.status) {
        return HttpErrorHandler.handleServerError(response);
      }

      switch (response.status) {
        case 400:
           return new HttpRequestError('', 'app.common.error.server.bad.request', response.status, response);
        case 401:
          return new HttpRequestError('', 'app.loginpage.error.invalid.credentials', response.status, response);
        case 403:
          return new HttpRequestError('', 'app.loginpage.error.auth.denied', response.status, response);
        case 404:
          return new HttpRequestError('', 'app.common.error.server.request.failed', response.status, response);
        case 503:
          return new HttpRequestError('', 'app.common.error.server.temp.unavailable', response.status, response);
        default:
          return new HttpRequestError('', 'app.common.error.server.unknown', response.status, response);
      }

    }
}
